// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__42N+0","footer_icons":"footer_footer_icons__v-IWv"};